import { getBrowserTimezone } from '../../../../utils/timezone';

// Reports excluidos do MVP (por nome/referenceId)
export const EXCLUDED_REPORTS_MVP = [
  'Scheduled-and-Actual-Lease-Charges',
  'Report-Centralized-Work-Orders',
  'Report-Minnesota-CRP',
  // Shared MN CRP Export catalog row, matched by id since it has no referenceId
  'c3f5a1e2-7b4d-4e8a-9c61-2d0f8b3e5a17',
];

// Reuse the shared referenceId so it never drifts from the backend value (ENG-27547)
export { LEASE_CHANGE_OUT_REF_ID } from '../../../../components/CreateReportModal/constants';

// Lease Type options for the Lease Change Out report's conditional dropdown
export const LEASE_TYPE_OPTIONS = [
  { value: 'new-lease', text: 'New Lease' },
  { value: 'renewal', text: 'Renewal' },
  { value: 'all', text: 'All' },
];

// Legacy reports that only support CSV (no PDF)
// Consistent with property-level Create Report modal behavior
export const CSV_ONLY_REPORT_REFERENCE_IDS = [
  'Monthly-Summary-Transactions',
  'Scheduled-Lease-Charges',
  'Recent-Payment',
  'Resident-Ledgers-Customer-Ops',
];

export const FREQUENCY_OPTIONS = [
  { label: 'Daily', value: 'daily', size: 'small' },
  { label: 'Weekly', value: 'weekly', size: 'small' },
  { label: 'Monthly', value: 'monthly', size: 'small' },
  { label: 'Date', value: 'one-time', size: 'small' },
];

export const REPORTING_PERIOD_OPTIONS = [
  { label: 'As of Date', value: 'asOfDate', size: 'small' },
  { label: 'Period to Date', value: 'periodToDate', size: 'small' },
];

export const DAY_OF_WEEK_OPTIONS = [
  { text: 'Sunday', value: '0' },
  { text: 'Monday', value: '1' },
  { text: 'Tuesday', value: '2' },
  { text: 'Wednesday', value: '3' },
  { text: 'Thursday', value: '4' },
  { text: 'Friday', value: '5' },
  { text: 'Saturday', value: '6' },
];

export const DAY_OF_MONTH_OPTIONS = [
  ...Array.from({ length: 28 }, (_, i) => ({
    text: String(i + 1),
    value: String(i + 1),
  })),
  { text: 'Last day of month', value: '-1' },
];

export const AM_PM_OPTIONS = [
  { text: 'AM', value: 'AM' },
  { text: 'PM', value: 'PM' },
];

export const TIME_OPTIONS = [
  { text: '12:00', value: '12:00' },
  { text: '12:30', value: '12:30' },
  { text: '1:00', value: '1:00' },
  { text: '1:30', value: '1:30' },
  { text: '2:00', value: '2:00' },
  { text: '2:30', value: '2:30' },
  { text: '3:00', value: '3:00' },
  { text: '3:30', value: '3:30' },
  { text: '4:00', value: '4:00' },
  { text: '4:30', value: '4:30' },
  { text: '5:00', value: '5:00' },
  { text: '5:30', value: '5:30' },
  { text: '6:00', value: '6:00' },
  { text: '6:30', value: '6:30' },
  { text: '7:00', value: '7:00' },
  { text: '7:30', value: '7:30' },
  { text: '8:00', value: '8:00' },
  { text: '8:30', value: '8:30' },
  { text: '9:00', value: '9:00' },
  { text: '9:30', value: '9:30' },
  { text: '10:00', value: '10:00' },
  { text: '10:30', value: '10:30' },
  { text: '11:00', value: '11:00' },
  { text: '11:30', value: '11:30' },
];

export const FORMAT_OPTIONS = [
  { text: 'CSV', value: 'csv' },
  { text: 'Excel', value: 'xlsx' },
];

// TIMEZONE_OPTIONS is defined for future use when timezone selection UI is implemented.
// Currently only DEFAULT_TIMEZONE is used.
export const TIMEZONE_OPTIONS = [
  { text: 'America/Chicago (CST)', value: 'America/Chicago' },
  { text: 'America/New_York (EST)', value: 'America/New_York' },
  { text: 'America/Los_Angeles (PST)', value: 'America/Los_Angeles' },
  { text: 'America/Denver (MST)', value: 'America/Denver' },
  { text: 'UTC', value: 'UTC' },
];

// Resolved at module load using the user's browser timezone so the schedule
// fires in the timezone the user actually picked the executionTime from.
// Falls back to America/Chicago when Intl is unavailable. The value is captured
// once at module load and will not reflect runtime OS timezone changes; that is
// acceptable since the modal is short lived and a page refresh re-evaluates it.
// ENG-27666.
export const DEFAULT_TIMEZONE = getBrowserTimezone();
